<template>
  <div>
    <div
      :tabindex="0"
      :class="['radio-button-component', classe, { 'loading-radio': loading }]"
      :name="nameRadio"
      type="radio"
      slot="radio"
      @click="handleSeleciona(imposto)"
      @keyup.enter="handleSeleciona(imposto)"
    />
  </div>
</template>

<script lang="js">
export default {
    name: 'RadioButton',

    props: {
        seleciona: Function,
        posicao: Number,
        nameRadio: String,
        imposto: Object | Array,
        loading: Boolean,
        classe: String
    },

    methods: {
      handleSeleciona(imposto) {
        if (this.loading) {
          return
        }
        this.seleciona(imposto)
      }
    },
}
</script>

<style scoped lang="scss" scoped>
div[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 2px;
  /* background-color only for content */
  background-clip: content-box;
  border: 1px solid;
  background-color: var(--branco);
  border-radius: 50%;
  cursor: pointer;
}

div[type="radio"]:hover {
  background-color: #ccc;
  padding: 0px;
}

div[type="radio"]:checked {
  background-color: #72b118 !important;
  padding: 2px !important;
}

.radio-button-component {
  width: 16px;
  height: 16px;
  margin: 0.75rem 5px 0 0;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:focus {
    border: 3px solid;
  }
}

.preferencia_tarifaria,
.exportacao,
.class_importacao {
  border-color: var(--importacao) !important;
}

.pis_cofins,
.cide_combustivel {
  border-color: var(--pis-cofins) !important;
}

.icms_interno,
.icms_st,
.icms,
.carga_liquida,
.difal,
.antecipacao {
  border-color: var(--icms) !important;
}

.ipi {
  border-color: var(--ipi) !important;
}

.loading-radio {
  opacity: 0.3;
  cursor: not-allowed !important;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@media only print {
  .radio-button-component {
    display: none;
  }
}
</style>
